/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Upwork_HighlightInputs */

const en_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire on Upwork`)
};

const ar_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const bn_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const de_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const es_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const fr_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const pt_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork`)
};

const zh_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Upwork 上招聘`)
};

const tr_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork'te İşe Alma`)
};

const ru_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нанимайте на Upwork`)
};

const pl_heading_contact_upwork_highlight = /** @type {(inputs: Heading_Contact_Upwork_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij w Upwork`)
};

/**
* | output |
* | --- |
* | "Hire on Upwork" |
*
* @param {Heading_Contact_Upwork_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_upwork_highlight = /** @type {((inputs?: Heading_Contact_Upwork_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Upwork_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_upwork_highlight(inputs)
	if (locale === "bn") return bn_heading_contact_upwork_highlight(inputs)
	if (locale === "de") return de_heading_contact_upwork_highlight(inputs)
	if (locale === "es") return es_heading_contact_upwork_highlight(inputs)
	if (locale === "fr") return fr_heading_contact_upwork_highlight(inputs)
	if (locale === "pt") return pt_heading_contact_upwork_highlight(inputs)
	if (locale === "zh") return zh_heading_contact_upwork_highlight(inputs)
	if (locale === "tr") return tr_heading_contact_upwork_highlight(inputs)
	if (locale === "ru") return ru_heading_contact_upwork_highlight(inputs)
	if (locale === "pl") return pl_heading_contact_upwork_highlight(inputs)
	return en_heading_contact_upwork_highlight(inputs)
});